'use es6';

import Application from './app';
new Application().init();